import BaseEvaluator from './BaseEvaluator';

export default class IPEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'email';
  }

  validate() {
    if (this.value === null || this.value === '') {
      // Allow blank
      this.isValid = true;
    } else if (this.mutator[0] === null) {
      this.isValid = this.isIPv4() || this.isIPv6();
    } else if (this.mutator[0] === 'v4') {
      this.isValid = this.isIPv4();
    } else if (this.mutator[0] === 'v6') {
      this.isValid = this.isIPv6();
    }
    return this.isValid;
  }

  isIPv4() {
    if (this.value !== undefined && this.value !== null) {
      return (
        `${this.value}`.match(
          /^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/,
        ) !== null
      );
    }
    return true;
  }

  isIPv6() {
    const components = this.value.split(':');
    if (components.length < 2 || components.length > 8) {
      return false;
    }
    if (components[0] !== '' || components[1] !== '') {
      // Address does not begin with a zero compression ("::")
      if (!components[0].match(/^[\da-f]{1,4}/i)) {
        // Component must contain 1-4 hex characters
        return false;
      }
    }

    let numberOfZeroCompressions = 0;
    for (let i = 1; i < components.length; i += 1) {
      if (components[i] === '') {
        // We're inside a zero compression ("::")
        numberOfZeroCompressions += 1;
        if (numberOfZeroCompressions > 1) {
          // Zero compression can only occur once in an address
          return false;
        }
      } else if (!components[i].match(/^[\da-f]{1,4}/i)) {
        // Component must contain 1-4 hex characters
        return false;
      }
    }
    return true;
  }
}
